import $ from 'jquery';
import def from './fieldWidget.def.js';
$.widget('formBuilder.fieldWidget', def);



// WEBPACK FOOTER //
// ./src/widgets/fieldWidget.js